const http = {
  bad_request: 400,
  unauthorized: 401,
  not_found: 404,
  duplicate: 409,
  internal: 500,
};

export default http;
